import React from "react";
import styled from "styled-components";

interface StyledSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const SwitchWrapper = styled.div<{ checked: boolean }>`
  width: 43px;
  height: 20px;
  border-radius: 9999px;
  background-color: ${(props) => props.checked ? "#003366" : "#ccc"};
  display: flex;
  align-items: center;
  padding: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
`;

const Thumb = styled.div<{ checked: boolean }>`
  width: 17px;
  height: 17px;
  border-radius: 50%;
  background-color: white;
  transition: transform 0.3s ease;
  transform: ${(props) => (props.checked ? "translateX(21px)" : "translateX(0)")};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`;

const StyledSwitch: React.FC<StyledSwitchProps> = ({ checked, onChange }) => {
  return (
    <SwitchWrapper checked={checked} onClick={() => onChange(!checked)}>
      <Thumb checked={checked} />
    </SwitchWrapper>
  );
};

export default StyledSwitch;
